export default __webpack_public_path__ + "static/AppBeers12-23906562091fc7bbbbf533809b1027b1.png";